import { Layout, Menu, Switch, Button, Drawer } from 'antd';
import { Link, useLocation } from "react-router-dom";
import { HomeOutlined, EllipsisOutlined } from '@ant-design/icons';
import { useState } from "react";

const { Header: AntHeader } = Layout;

const navHighlightColor = "#001529";

const getSelectedKey = (pathname) => {
  if (pathname.startsWith("/insights")) return "3";
  if (pathname.startsWith("/changelog")) return "2";
  if (pathname.startsWith("/contact")) return "6";
  if (pathname === "/") return "1";
  return "1";
};

export const Header = (props) => {
  const location = useLocation();
  const selectedKey = getSelectedKey(location.pathname);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navBackgroundColor = props.isDarkMode ? "#001529" : "rgba(255, 255, 255, 0.9)";
  const navTextColor = props.isDarkMode ? "#ffffff" : "#0f172a";
  const navBorderColor = props.isDarkMode
    ? "1px solid rgba(0, 21, 41, 0.6)"
    : "1px solid rgba(31, 42, 68, 0.08)";
  const navShadowColor = props.isDarkMode
    ? "0 10px 24px rgba(0, 21, 41, 0.25)"
    : "0 10px 24px rgba(31, 42, 68, 0.08)";

  const width = props.width ?? 1200;
  const visibleKeys = getVisibleKeys(width);
  const navItems = items(props.small, navTextColor, () => setIsMobileMenuOpen(false));
  const visibleItems = navItems.filter((item) => visibleKeys.includes(item.key));
  const overflowItems = navItems.filter((item) => !visibleKeys.includes(item.key));
  const hasOverflow = overflowItems.length > 0;

  return (
    <>
      <AntHeader style={{
        position: 'sticky', top: 0,
        zIndex: 1000,
        padding: '0 24px',
        background: navBackgroundColor,
        borderBottom: navBorderColor,
        boxShadow: navShadowColor,
        backdropFilter: 'blur(10px)',
      }}>
        <style>{`
          .main-nav.ant-menu-horizontal > .ant-menu-item-selected::after,
          .main-nav.ant-menu-horizontal > .ant-menu-submenu-selected::after,
          .main-nav.ant-menu-horizontal > .ant-menu-item:hover::after,
          .main-nav.ant-menu-horizontal > .ant-menu-submenu:hover::after {
            border-bottom-color: ${navHighlightColor};
          }
        `}</style>
        <div style={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
        }}>
          <>
            <Menu
              mode="horizontal"
              selectedKeys={[selectedKey]}
              items={visibleItems}
              className="main-nav"
              style={{
                background: 'transparent',
                borderBottom: 'none',
                fontWeight: 500,
                color: navTextColor,
                flex: 1,
                minWidth: 0,
              }}
            />
            {hasOverflow && (
              <>
                <Button
                  type="text"
                  aria-label="Open navigation menu"
                  icon={<EllipsisOutlined style={{ fontSize: 24, color: navTextColor }} />}
                  onClick={() => setIsMobileMenuOpen(true)}
                />
                <Drawer
                  title="Menu"
                  placement="top"
                  height="auto"
                  open={isMobileMenuOpen}
                  onClose={() => setIsMobileMenuOpen(false)}
                  bodyStyle={{ padding: 0 }}
                >
                  <Menu
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    items={overflowItems}
                    style={{ borderRight: 'none' }}
                  />
                  <div style={{ padding: 16, borderTop: "1px solid rgba(0, 0, 0, 0.06)" }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontSize: 14 }}>
                        {props.isDarkMode ? "Dark" : "Light"}
                      </span>
                      <Switch checked={props.isDarkMode} onChange={props.onToggleDarkMode} />
                    </div>
                  </div>
                </Drawer>
              </>
            )}
            {!hasOverflow && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ color: navTextColor, fontSize: 14 }}>
                  {props.isDarkMode ? "Dark" : "Light"}
                </span>
                <Switch checked={props.isDarkMode} onChange={props.onToggleDarkMode} />
              </div>
            )}
          </>
        </div>
      </AntHeader>
    </>
  );
};

const getVisibleKeys = (width) => {
  if (width >= 1100) return ["1", "3", "2", "4", "6"];
  if (width >= 980) return ["1", "3", "2", "4"];
  if (width >= 860) return ["1", "3", "2"];
  if (width >= 740) return ["1", "3"];
  return ["1"];
};

const items = (small, textColor, onItemClick) => [
  { key: "1", label: generateCursiveItemsLink(home, small, textColor, onItemClick), icon: (<HomeOutlined style={{ fontSize: "25px", color: textColor }}/>) },
  { key: "3", label: generateItemsLink(insights, textColor, onItemClick) },
  { key: "2", label: generateItemsLink(changelog, textColor, onItemClick) },
  { key: "4", label: generateItemsLink(works, textColor, onItemClick), disabled: "true" },
  { key: "6", label: generateItemsLink(contact, textColor, onItemClick) },
];



const generateCursiveItemsLink = (item, small, textColor, onItemClick) =>
  <b style={{  }}>
    <Link
      style={{ ...(small ? noUnderLiSm : item.style), color: textColor }}
      to={item.link}
      onClick={onItemClick}
    >
      {item.text}
    </Link>
  </b>;

const generateItemsLink = (item, textColor, onItemClick) => (
  <Link style={{ ...item.style, color: textColor }} to={item.link} onClick={onItemClick} > {item.text} </Link>
);

const noUnderLi = {
    textDecoration: 'none',
    fontSize: "25px",
    fontWeight: 600,
}
const noUnderLiSm = {
    textDecoration: 'none',
    fontSize: "20px",
    fontWeight: 600,
}
const noUnderLiVerdana = {
    textDecoration: 'none',
    fontSize: "20px",
    fontWeight: 500,
}

const home = {
    style: noUnderLi,
    link: "/",
    text: "Dilks Software Solutions"
}
const changelog = {
    style: noUnderLiVerdana,
    link: "/changelog",
    text: "Changelog"
}
const insights = {
    style: noUnderLiVerdana,
    link: "/insights",
    text: "Insights"
}
const works = {
    style: noUnderLiVerdana,
    text: "Works"
}
const contact = {
    style: noUnderLiVerdana,
    text: "Contact Us",
    link: "/contact"
}

